import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { languages } from "../constants/languages";
import { getUpgradeCheckoutURL } from "../util/OpenUpgradeCheckout";

const olympicPic = require("../img/olympic.png");

export default class UpgradeDialog extends React.Component {
  state = {
    freeVersionClicked: false,
    fetchingCheckoutURL: false,
    checkoutURL: null,
    checkoutError: false,
  };

  componentDidMount = () => {
    if (this.props.open) {
      this.fetchCheckoutURL();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (!prevProps.open && this.props.open) {
      this.fetchCheckoutURL();
    }
  };

  fetchCheckoutURL = async () => {
    if (this.state.fetchingCheckoutURL || (this.props.userData || {}).isPSD) {
      return;
    }
    this.setState({ fetchingCheckoutURL: true, checkoutError: false });
    const checkoutURL = await getUpgradeCheckoutURL(
      this.props.tournament[".key"],
      this.props.tournament
    );
    this.setState({
      checkoutURL: checkoutURL,
      checkoutError: checkoutURL === null,
      fetchingCheckoutURL: false,
    });
  };

  handleUpgrade = (e) => {
    e.preventDefault();
    if (!this.state.checkoutURL) {
      return;
    }
    if (window.firebase.analytics) {
      window.firebase.analytics().logEvent("upgrade_button_clicked");
    }
    // The URL is prefetched when the dialog opens so we can navigate
    // synchronously here; Safari blocks window.open after an await as a popup
    window.open(this.state.checkoutURL, "_blank");
  };

  render() {
    let isPSDUser = false;
    if ((this.props.userData || {}).isPSD) {
      isPSDUser = true;
    }
    return !isPSDUser ? (
      <Dialog
        open={this.props.open}
        onClose={() => {
          this.props.toggleDialog();
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.structurePage
            ? ""
            : languages.upgrade.upgradeThisTournament}
        </DialogTitle>
        {!this.props.structurePage && (
          <React.Fragment>
            <DialogContent style={{ width: 600, maxWidth: "100%" }}>
              <DialogContentText>
                {languages.upgrade.upgradeGenericText}
              </DialogContentText>
              {this.state.checkoutError && (
                <DialogContentText color="error">
                  {languages.upgrade.checkoutError}
                </DialogContentText>
              )}
            </DialogContent>
            <DialogActions style={{ padding: 24, paddingTop: 0 }}>
              <div style={{ position: "relative", display: "inline" }}>
                <Button
                  onClick={this.handleUpgrade}
                  variant="contained"
                  color="primary"
                  disabled={!this.state.checkoutURL}
                >
                  {languages.upgrade.seePackages}
                </Button>
                {this.state.fetchingCheckoutURL && (
                  <CircularProgress
                    size={24}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: -12,
                      marginLeft: -12,
                    }}
                  />
                )}
              </div>
            </DialogActions>
          </React.Fragment>
        )}
        {this.props.structurePage && !this.state.freeVersionClicked && (
            <DialogContent>
              {" "}
              <DialogContentText style={{ maxWidth: 400 }}>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <img
                    style={{ height: 80, margin: "0 auto" }}
                    src={olympicPic}
                    alt=""
                  />
                </div>
                <br />

                {languages.formatString(
                  languages.upgrade.upgradeOrTestFreeVersion,
                  this.props.maxTeams === 60
                    ? languages.upgrade.maxTeamsWorldclass
                    : languages.upgrade.maxTeamsFree,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
                <br />
                <br />
                <span
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginRight: 10,
                    marginBottom: 5,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={(e) => {
                      if (window.firebase.analytics) {
                        window.firebase
                          .analytics()
                          .logEvent("see_packages_button_clicked");
                      }
                      this.handleUpgrade(e);
                    }}
                    disabled={!this.state.checkoutURL}
                    color="primary"
                  >
                    {languages.upgrade.seePackages}
                  </Button>
                  {this.state.fetchingCheckoutURL && (
                    <CircularProgress
                      size={24}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: -12,
                        marginLeft: -12,
                      }}
                    />
                  )}
                </span>
                <Button
                  style={{ marginBottom: 5 }}
                  variant="outlined"
                  onClick={(e) => {
                    if (window.firebase.analytics) {
                      window.firebase
                        .analytics()
                        .logEvent("free_version_button_clicked");
                    }
                    this.props.maxTeams === 60
                      ? this.props.toggleDialog()
                      : this.setState({ freeVersionClicked: true });
                  }}
                  color="primary"
                >
                  {this.props.maxTeams === 60
                    ? languages.upgrade.testCurrentPackage
                    : languages.upgrade.testFreeVersion}
                </Button>
                {this.state.checkoutError && (
                  <Typography
                    component="span"
                    color="error"
                    variant="body2"
                    style={{ display: "block", marginTop: 10 }}
                  >
                    {languages.upgrade.checkoutError}
                  </Typography>
                )}
              </DialogContentText>
            </DialogContent>
          )}

        {this.props.structurePage && this.state.freeVersionClicked && (
          <DialogContent>
            {" "}
            <DialogContentText style={{ maxWidth: 400 }}>
              <div style={{ width: "100%", textAlign: "center" }}>
                <img
                  style={{ height: 80, margin: "0 auto" }}
                  src={olympicPic}
                  alt=""
                />
              </div>
              <br />

              {languages.upgrade.freeVersionText}
              <br />
              <br />
              <Button
                style={{ marginBottom: 5 }}
                variant="contained"
                onClick={() => {
                  this.props.toggleDialog();
                  if (this.props.structurePage) {
                    this.setState({ freeVersionClicked: false });
                  }
                }}
                color="primary"
              >
                {languages.upgrade.letsGo}
              </Button>
            </DialogContentText>
          </DialogContent>
        )}
      </Dialog>
    ) : (
      <Dialog
        open={this.props.open}
        onClose={() => {
          this.props.toggleDialog();
        }}
      >
        <DialogTitle>{languages.upgrade.psdUpgradeTitle}</DialogTitle>
        <DialogContent style={{ width: 600, maxWidth: "100%" }}>
          <DialogContentText>
            {languages.formatString(
              languages.upgrade.psdUpgradeText,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}
